export const appInfo = [
  { 
    name: 'saas',
    dev: `https://localhost:8879`
  },
  { 
    name: 'raas',
    dev: `http://localhost:8878`
  },
  { 
    name: 'cms',
    // dev: 'http://cms-admin.testing3.wdeduc.com'
    dev: 'http://localhost:8080'
  },
  { 
    name: 'custom',
    // dev: 'http://cms-admin.testing3.wdeduc.com'
    dev: 'http://localhost:8081'
  },
  { 
    name: 'payment',
    dev: 'http://localhost:8880'
  },
  {
    name: 'maas',
    dev: 'http://localhost:10080'
  },
  {
    name: 'management',
    dev: 'http://localhost:8083'
  },
  {
    name: 'form',
    dev: 'http://localhost:8183'
  },
  {
    name: 'agentmanage',
    dev: 'http://localhost:8083'
  },
  {
    name: 'modular',
    dev: 'http://localhost:80'
  },
  {
    // 开发人员平台
    name: 'dev',
    dev: 'http://localhost:8872'
  },
  {
    // 系统治理平台
    name: 'govern-system',
    dev: 'http://localhost:8866'
  },
  {
    // 数据中台
    name: 'daas',
    dev: 'http://localhost:8881'
  },
  {
    // toc平台
    name: 'c-admin',
    dev: 'http://localhost:8882'
  },
  {
    // 聚好活后台
    name: 'jhh-admin',
    dev: 'http://localhost:8881'
  },
  {
    // 低代码form表单
    name: 'lowcode-admin',
    dev: 'http://localhost:8881'
  },
  {
    // 交通安全托管
    name: 'traffic',
    dev: 'http://localhost:8881'
  },
  {
    // 溪午青禾
    name: 'xwqh-admin',
    dev: 'http://localhost:8881'
  }
]
const base = require('js-base64').Base64;
const hostname = window.location.hostname
const port = window.location.port;

let envArr = ['testing1', 'testing2', 'testing3', 'fat', 'uat'];
let env = window.location.port ? 'testing3' : '';
envArr.forEach(d => {
  if (window.location.hostname.includes(d)) {env = d}
})
let API = env ? `${window.location.protocol}//hrss-api.${env}.wdeduc.com` : `${window.location.protocol}//hrss-api.wdeduc.com`;
// API = 'https://hrss-api.uat.wdeduc.com'//临时访问UAT环境的接口

// API = `https://hrss-api.testing3.wdeduc.com`;//临时访问3环境的接口


if (hostname.indexOf('testing2') !== -1) {
    // testing2直接走testing3
    // API = `https://hrss-api.testing3.wdeduc.com`;
}
if (hostname.indexOf('testing1') !== -1) {
    // testing2直接走testing3
    API = `https://hrss-api.testing3.wdeduc.com`;
}

// 获取可视化配置的，本地调试可修改对应的环境
const confUrl = port? base.encode('i18n.testing3.wdeduc.com') :  base.encode(hostname);

export default {
  env,
  appInfo,
  API,
  confUrl
}